import { useGetAccountQuery } from '@/services/accounts';
import { toast } from '@palmetto/palmetto-components';

import { MilestoneType, Account } from 'types';

export function useToastSuccessSavedPackageMessage(accountId: string, milestoneType: MilestoneType): () => void {
  const { data: account } = useGetAccountQuery<{ data: Account }>(accountId);
  const packageName = (() => {
    switch (milestoneType) {
      case MilestoneType.install:
        return 'Install Package';
      case MilestoneType.loopField:
        return 'Loop Field Package';
      case MilestoneType.activation:
        return 'Activation Package';
      case MilestoneType.postActivation:
        return 'Post Activation Package';
      default:
        return 'Package';
    }
  })();

  return () => {
    const currentMilestone = account?.currentMilestone;
    const storedMilestone = account?.milestones?.find((milestone) => milestone.type === milestoneType);
    const message =
      (currentMilestone?.order || 0) < (storedMilestone?.order || 0)
        ? `${packageName} has been saved, but cannot be submitted to Palmetto LightReach for review until previous Milestones have been approved.`
        : `${packageName} Saved.`;
    toast.success(message);
  };
}
